import React, { useEffect, useRef, useState } from 'react';
import './CreateEstimate.css';
import loginLogo from '../../../../assets/img/login-logo2.svg';
import logoHover from '../../../../assets/img/login-logohover.svg';
import logoHover2 from '../../../../assets/img/login-logohover2.svg';
import leftArrow from '../../../../assets/img/white-left-icon.svg';
import { useNavigate } from 'react-router-dom';
import Header from '../../../../components/Header';
import { DragDropContext, Droppable, Draggable } from '@hello-pangea/dnd';
import Switch from '../../../../assets/img/switch-icon.svg';
import homeIcon from '../../../../assets/img/homeIcon.svg';
import edit from '../../../../assets/img/edit-01.svg';
import copyIcon from '../../../../assets/img/copy-icon.svg';
import delete4 from '../../../../assets/img/delete4.svg';
import appToast, { TOAST_TYPE } from 'utils/AppToast';
import APIServices from 'services/APIServices';
import {
  descriptionLimit,
  formatCurrency,
  isOptionEmpty,
  lineItemLimit,
  priceLimit,
  selectLoader,
  titleLimit
} from 'utils/Helpers';
import DeleteModal from 'components/DeleteModal';
import { Popover } from 'react-tiny-popover';
import ShareClientPopover from 'components/ShareClientPopover';

const CreateEstimate = ({
  changeOrderDetails,
  data,
  projectId,
  changeReqId = '',
  qouteId = '',
  isPreview,
  setIsPreview,
  isManualFlow = false,
  onSwitchToAI,
  parentId,
  projectTeam,
   currentQuoteId,
  setCurrentQuoteId,
}) => {
  const navigate = useNavigate();
  const shouldRefetchQuote = useRef(true);
  const inputRefs = useRef({});
  const scrollContainerRef = useRef(null);
  const [options, setOptions] = useState([]);
  const [newOptionId, setNewOptionId] = useState(1);
  const [editingOptionId, setEditingOptionId] = useState(null);
  const [expirationDays, setExpirationDays] = useState(30);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [isEditing, setEditing] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [optionToDelete, setOptionToDelete] = useState(null);
  const [showShare, setShowShare] = useState(false);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [shareLoading, setShareLoading] = useState(false);
  const [pageLoading, setPageLoading] = useState(false);
  const preparePayload = () => {
    return {
      projectId,
      expireInDays: expirationDays,
      projectRequestId: changeReqId,
      estimateTitle: changeOrderDetails?.title || '',
      estimateDescription: changeOrderDetails?.description || '',
      options: options.map((opt, index) => {
        const base = {
          sequence: opt.sequence ?? index,
          type: opt.type,
          title: opt.title,
          description: opt.description,
          additionalCost: opt.additionalCost,
          numberOfDays: opt.numberOfDays,
          lineItems: opt.lineItems.map((item) => {
            const lineBase = {
              title: item.title,
              description: item.description,
              estimatedCost: item.estimatedCost,
              numberOfDays: item.numberOfDays
            };

            // ✅ Only send _id in edit mode
            // if (isEditing && item._id) {
            lineBase._id = item._id;
            // }

            return lineBase;
          })
        };

        // ✅ Only send option _id in edit mode
        if (isEditing && opt._id) {
          base._id = opt._id;
        }

        return base;
      })
    };
  };

  useEffect(() => {
    if (qouteId) {
      setCurrentQuoteId(qouteId);
    }
  }, [qouteId]);

  useEffect(() => {
    if (!currentQuoteId) return;

    setEditing(true);

    // ✅ skip refetch after save/update
    if (!shouldRefetchQuote.current) {
      shouldRefetchQuote.current = true;
      return;
    }

    fetchQuoteDetails();
  }, [currentQuoteId]);

  useEffect(() => {
    console.log(projectTeam, 'projectTeamprojectTeam');
  }, [projectTeam]);

  const fetchQuoteDetails = async () => {
    try {
      setPageLoading(true);

      const response = await APIServices.get(`/project-request-quote/${currentQuoteId}`);

      if (response.data) {
        // const normalized = response.data.options.map((opt) => ({
        //   ...opt,
        //   lineItems: opt.lineItems.map((item, index) => ({
        //     ...item,
        //     id: item.id || `${opt._id}-${index}`
        //   }))
        // }));
        const normalized = response.data.options;
        setOptions(normalized);
        setNewOptionId(normalized.length + 1);
        setExpirationDays(response.data.expireInDays || 30);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setPageLoading(false);
    }
  };

  useEffect(() => {
    if (data?.options) {
      const normalized = data?.options;
      console.log(data?.options, 'data?.optionsdata?.options');

      setOptions(normalized);
      setNewOptionId(normalized.length + 1);
    } else {
      setOptions([
        {
          _id: 1,
          sequence: 1,
          type: 'Option 1',
          title: '',
          description: '',
          additionalCost: '',
          numberOfDays: '',
          lineItems: [
            {
              id: Date.now(),
              title: '',
              description: '',
              estimatedCost: '',
              numberOfDays: ''
            }
          ]
        }
      ]);
    }
  }, [data]);

  const handleOptionChange = (id, key, value) => {
    // update value
    setOptions((prev) => prev.map((opt) => (opt._id === id ? { ...opt, [key]: value } : opt)));

    // clear error for that field
    setErrors((prev) => {
      if (!prev[id]) return prev;

      return {
        ...prev,
        [id]: {
          ...prev[id],
          [key]: false
        }
      };
    });
  };

  const handleAddLineItem = (optionId) => {
    const newId = Date.now();

    setOptions((prev) =>
      prev.map((opt) =>
        opt._id === optionId
          ? {
              ...opt,
              lineItems: [
                ...opt.lineItems,
                {
                  id: newId,
                  title: '',
                  description: '',
                  estimatedCost: '',
                  numberOfDays: ''
                }
              ]
            }
          : opt
      )
    );

    return newId; // 👈 important
  };
  const handleKeyDown = (e, optionId) => {
    if (e.key === 'Enter') {
      e.preventDefault();

      const newId = handleAddLineItem(optionId);

      setTimeout(() => {
        inputRefs.current[newId]?.focus();
      }, 0);
    }
  };
  const handleLineItemChange = (optionId, lineId, value, itemIndex) => {
    setOptions((prev) =>
      prev.map((opt) =>
        opt._id === optionId
          ? {
              ...opt,
              lineItems: opt.lineItems.map((item) => (item._id === lineId ? { ...item, title: value } : item))
            }
          : opt
      )
    );

    // clear error
    setErrors((prev) => {
      if (!prev[optionId]?.lineItems) return prev;

      const updatedLineItems = [...prev[optionId].lineItems];
      updatedLineItems[itemIndex] = {
        ...updatedLineItems[itemIndex],
        title: false
      };

      return {
        ...prev,
        [optionId]: {
          ...prev[optionId],
          lineItems: updatedLineItems
        }
      };
    });
  };
  const handleRemoveLineItem = (optionId, lineId) => {
    setOptions((prev) =>
      prev.map((opt) => {
        if (opt._id !== optionId) return opt;

        // if only 1 item → reset instead of delete
        if (opt.lineItems.length === 1) {
          return {
            ...opt,
            lineItems: [
              {
                ...opt.lineItems[0],
                title: '',
                description: '',
                estimatedCost: '',
                numberOfDays: ''
              }
            ]
          };
        }

        // normal delete
        return {
          ...opt,
          lineItems: opt.lineItems.filter((item) => item._id !== lineId)
        };
      })
    );

    // ✅ FIXED ERROR HANDLING
    setErrors((prev) => {
      if (!prev[optionId]?.lineItems) return prev;

      const option = options.find((o) => o._id === optionId);
      if (!option) return prev;

      // if only 1 → reset errors
      if (option.lineItems.length === 1) {
        return {
          ...prev,
          [optionId]: {
            ...prev[optionId],
            lineItems: [{ title: false }]
          }
        };
      }

      // remove corresponding error index
      const indexToRemove = option.lineItems.findIndex((i) => i.id === lineId);

      const updatedErrors = [...prev[optionId].lineItems];
      updatedErrors.splice(indexToRemove, 1);

      return {
        ...prev,
        [optionId]: {
          ...prev[optionId],
          lineItems: updatedErrors
        }
      };
    });
  };
  const handleAddOption = () => {
    const lastOption = options[options.length - 1];

    if (lastOption) {
      const validation = validateOption(lastOption);

      const hasError =
        validation.type ||
        validation.title ||
        validation.description ||
        validation.additionalCost ||
        validation.numberOfDays ||
        validation.lineItems.some((li) => li.title);

      if (hasError) {
        setErrors({ [lastOption._id]: validation });
        return;
      }
    }

    setErrors({});

    setOptions((prev) => {
      const updated = [
        ...prev,
        {
          _id: newOptionId,
          type: `Option ${options.length + 1}`,
          title: '',
          description: '',
          additionalCost: '',
          numberOfDays: '',
          lineItems: [
            {
              id: Date.now(),
              title: '',
              description: '',
              estimatedCost: '',
              numberOfDays: ''
            }
          ]
        }
      ];

      return normalizeSequence(updated);
    });

    setNewOptionId((prev) => prev + 1);
    setTimeout(() => {
      scrollContainerRef.current?.scrollTo({
        left: scrollContainerRef.current.scrollWidth,
        behavior: 'smooth'
      });
    }, 100);
  };

  const normalizeSequence = (items) => {
    return items.map((opt, index) => ({
      ...opt,
      sequence: index
    }));
  };

  const handleCopyOption = (option) => {
    const newOption = {
      ...option,
      type: option.type + ' (Copy)',
      _id: Date.now(), // new unique id
      lineItems: option.lineItems.map((item) => ({
        ...item,
        id: Date.now() + Math.random()
      }))
    };

    setOptions((prev) => {
      const updated = [...prev, newOption];
      return normalizeSequence(updated);
    });
  };

  const validateOption = (option) => {
    let optionErrors = {};

    if (!option.type?.trim()) optionErrors.type = true;
    if (!option.title?.trim()) optionErrors.title = true;
    if (!option.description?.trim()) optionErrors.description = true;
    if (option.additionalCost === '' || Number(option.additionalCost) <= 0) {
      optionErrors.additionalCost = true;
    }

    if (option.numberOfDays === '' || Number(option.numberOfDays) <= 0) {
      optionErrors.numberOfDays = true;
    }

    optionErrors.lineItems = option.lineItems.map((item) => ({
      title: !item.title?.trim()
    }));

    return optionErrors;
  };
  const validateAllOptions = () => {
    let allErrors = {};
    let hasError = false;

    options.forEach((opt) => {
      const validation = validateOption(opt);

      const optionHasError =
        validation.type ||
        validation.title ||
        validation.description ||
        validation.additionalCost ||
        validation.numberOfDays ||
        validation.lineItems.some((li) => li.title);

      if (optionHasError) {
        allErrors[opt._id] = validation;
        hasError = true;
      }
    });

    return { hasError, allErrors };
  };
  const handleGenerateEstimate = () => {
    const { hasError, allErrors } = validateAllOptions();

    if (hasError) {
      setErrors(allErrors);
      return;
    }

    setErrors({});
    setIsPreview(true);
  };

  const handleSaveEstimate = async () => {
    try {
      setLoading(true);

      const payload = preparePayload();
      const { projectId, projectRequestId, ...editPayload } = payload;
      const response = isEditing
        ? await APIServices.put(`/project-request-quote/${currentQuoteId}`, editPayload)
        : await APIServices.post('/project-request-quote', payload);

      if (response?.message) {
        appToast(response.message, TOAST_TYPE.SUCCESS);
        // navigate(`/project-board/project/${projectId}`, {
        //   state: {
        //     openReqId: parentId, // ✅ use correct ID
        //     boardViewType: 'overview',
        //     isProjectRelatedBoard: true,
        //     projectId: projectId,
        //     isFromHome: true
        //   }
        // });
        const normalized = response.data.options;
        setOptions(normalized);
        setNewOptionId(normalized.length + 1);
        setExpirationDays(response.data.expireInDays || 30);
        const newQuoteId = response?.data?._id;
        shouldRefetchQuote.current = false;
        setCurrentQuoteId(newQuoteId);
        if (!isEditing) {
          setEditing(true);
        }
      } else {
        appToast(response?.data?.message || 'Something went wrong', TOAST_TYPE.ERROR);
      }
    } catch (error) {
      console.error(error);
      appToast('Failed to save estimate', TOAST_TYPE.ERROR);
    } finally {
      setLoading(false);
      if (document.activeElement instanceof HTMLElement) {
        document.activeElement.blur();
      }
    }
  };

  const confirmDeleteOption = () => {
    if (!optionToDelete) return;

    setOptions((prev) => {
      // ✅ if only one option exists → reset it instead of deleting
      if (prev.length === 1) {
        const resetOption = {
          ...prev[0],
          type: '',
          title: '',
          description: '',
          additionalCost: '',
          numberOfDays: '',
          lineItems: [
            {
              id: Date.now(),
              title: '',
              description: '',
              estimatedCost: '',
              numberOfDays: ''
            }
          ]
        };

        return [resetOption];
      }

      // ✅ normal delete
      const updated = prev.filter((opt) => opt._id !== optionToDelete);

      return normalizeSequence(updated);
    });

    // ✅ clear related errors
    setErrors((prev) => {
      const updatedErrors = { ...prev };
      delete updatedErrors[optionToDelete];
      return updatedErrors;
    });

    setOptionToDelete(null);
    setShowDeleteModal(false);
  };

  const handleOptionDragEnd = (result) => {
    const { source, destination } = result;

    if (!destination) return;

    if (source.index === destination.index && source.droppableId === destination.droppableId) {
      return;
    }

    const items = Array.from(options);
    const [moved] = items.splice(source.index, 1);
    items.splice(destination.index, 0, moved);

    // ✅ update sequence
    const updated = items.map((opt, index) => ({
      ...opt,
      sequence: index
    }));

    setOptions(updated);
  };
  const members = projectTeam || [];
  const handleSelectUser = (user) => {
    setSelectedUsers((prev) => [...prev, user]);
  };

  const handleRemoveUser = (id) => {
    setSelectedUsers((prev) => prev.filter((u) => u.value !== id));
  };

  const handleShareQuote = async () => {
    try {
      if (!currentQuoteId) {
        appToast('Save quote before sharing', TOAST_TYPE.ERROR);
        return;
      }

      if (!selectedUsers.length) {
        appToast('Please select at least one user', TOAST_TYPE.ERROR);
        return;
      }

      setShareLoading(true);

      const payload = {
        quoteId: currentQuoteId,
        userIds: selectedUsers.map((u) => u.value)
      };

      const response = await APIServices.post('/project-request-quote/share', payload);

      if (response?.message) {
        appToast(response.message, TOAST_TYPE.SUCCESS);

        // ✅ close popover after success
        setShowShare(false);
      } else {
        appToast('Failed to share quote', TOAST_TYPE.ERROR);
      }
    } catch (error) {
      console.error(error);
      appToast('Failed to share quote', TOAST_TYPE.ERROR);
    } finally {
      setShareLoading(false);
    }
  };

  if (pageLoading) {
    return <div className="nodata-loader">{selectLoader(60)}</div>;
  }

  return (
    <div className="wrapper estimate-wrapper">
      {/* <Header content={HeaderContent} /> */}
      <div className="main-content">
        <div className="container">
          {!isPreview ? (
            <>
              <div className="generation-card">
                <div className="aiGeneration-left">
                  {isManualFlow && (
                    <>
                      <p>Want to head start?</p>
                      <div className="switch-text cursor_pointer" onClick={onSwitchToAI}>
                        <img src={Switch} alt="File" className="switch-icon" />
                        <p>Switch to AI generation</p>
                      </div>
                    </>
                  )}
                </div>
                <div className="aiGeneration-right">
                  <p>Set Expiration Period</p>
                  <div className="switch-text">
                    <input
                      min="1"
                      max="365"
                      value={expirationDays}
                      className="form-control expiration-input"
                      onChange={(e) => {
                        let value = e.target.value.replace(/[^0-9]/g, '');

                        if (value === '') {
                          setExpirationDays('');
                          return;
                        }

                        value = Math.min(365, Math.max(1, Number(value))); // clamp between 1–365
                        setExpirationDays(value);
                      }}
                      onKeyDown={(e) => {
                        if (e.target.value.length >= 3 && e.key !== 'Backspace') {
                          e.preventDefault();
                        }
                      }}
                    />
                    Days
                  </div>
                </div>
              </div>
              <div className="create-card">
                <DragDropContext onDragEnd={handleOptionDragEnd}>
                  <Droppable droppableId="OPTIONS" direction="horizontal">
                    {(provided) => (
                      <div
                        className="create-cardCover"
                        ref={(el) => {
                          provided.innerRef(el);
                          scrollContainerRef.current = el;
                        }}
                        {...provided.droppableProps}
                        style={{ display: 'flex', gap: '16px', overflowX: 'auto' }}>
                        {options.map((option, index) => (
                          <Draggable key={option._id} draggableId={String(option._id)} index={index}>
                            {(provided) => (
                              <div
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                style={{
                                  ...provided.draggableProps.style,
                                  display: 'inline-block'
                                }}>
                                <div>
                                  <div className="option-cardCover">
                                    {/* 🔥 DRAG HANDLE HERE */}
                                    <div className="optionCard-head" {...provided.dragHandleProps}>
                                      <div className="optiontext">
                                        <img src={homeIcon} alt="File" className="homeIconn" />

                                        {editingOptionId === option._id ? (
                                          <input
                                            maxLength={titleLimit}
                                            className="option-name-input"
                                            value={option.type || ''}
                                            autoFocus
                                            onChange={(e) => handleOptionChange(option._id, 'type', e.target.value)}
                                            onBlur={() => setEditingOptionId(null)}
                                            onKeyDown={(e) => {
                                              // ✅ save on enter
                                              if (e.key === 'Enter') {
                                                e.preventDefault();
                                                setEditingOptionId(null);
                                              }

                                              // ✅ close edit mode on esc
                                              if (e.key === 'Escape') {
                                                setEditingOptionId(null);
                                              }
                                            }}
                                          />
                                        ) : (
                                          <>
                                            <p className="text-elipsis-activity">
                                              {option.type || `Option ${index + 1}`}
                                            </p>

                                            <img
                                              src={edit}
                                              alt="edit"
                                              className="edit-icon"
                                              onClick={() => setEditingOptionId(option._id)}
                                            />
                                          </>
                                        )}
                                      </div>

                                      <img
                                        src={copyIcon}
                                        alt="copy"
                                        className="copyIcon cursor_pointer"
                                        onClick={() => handleCopyOption(option)}
                                      />
                                    </div>

                                    {/* CONTENT (UNCHANGED) */}
                                    <div className="optionCard-content">
                                      <div className="row">
                                        <div className="col-lg-12">
                                          <div className="form-group">
                                            <label>Title</label>
                                            <input
                                              maxLength={titleLimit}
                                              type="text"
                                              className={`form-control ${
                                                errors[option._id]?.title ? 'error-border' : ''
                                              }`}
                                              value={option.title}
                                              onChange={(e) => handleOptionChange(option._id, 'title', e.target.value)}
                                              placeholder="Enter option title..."
                                            />
                                          </div>
                                        </div>
                                      </div>

                                      <div className="row">
                                        <div className="col-lg-12">
                                          <div className="form-group">
                                            <label>Description</label>
                                            <textarea
                                              maxLength={descriptionLimit}
                                              placeholder="Enter option description..."
                                              className={`description form-control ${
                                                errors[option._id]?.description ? 'error-border' : ''
                                              }`}
                                              value={option.description}
                                              onChange={(e) =>
                                                handleOptionChange(option._id, 'description', e.target.value)
                                              }
                                            />
                                          </div>
                                        </div>
                                      </div>

                                      <div className="line-item">
                                        <p>Line Items</p>
                                        <a
                                          className="cursor_pointer"
                                          onClick={(e) => {
                                            e.preventDefault();
                                            handleAddLineItem(option._id);
                                          }}>
                                          + Add
                                        </a>
                                      </div>

                                      <div className="row">
                                        {option.lineItems.map((item, itemIndex) => (
                                          <div className="col-lg-12" key={item.id}>
                                            <div className="form-group mb-10">
                                              <input
                                                maxLength={lineItemLimit}
                                                placeholder="Enter line item..."
                                                type="text"
                                                className={`form-control ${
                                                  errors[option._id]?.lineItems?.[itemIndex]?.title
                                                    ? 'error-border'
                                                    : ''
                                                }`}
                                                value={item.title}
                                                ref={(el) => {
                                                  if (el) inputRefs.current[item._id] = el;
                                                }}
                                                onChange={(e) =>
                                                  handleLineItemChange(option._id, item._id, e.target.value, itemIndex)
                                                }
                                                onKeyDown={(e) => handleKeyDown(e, option._id, item._id)}
                                              />

                                              <img
                                                src={delete4}
                                                className="delete4"
                                                onClick={() => handleRemoveLineItem(option._id, item._id)}
                                              />
                                            </div>
                                          </div>
                                        ))}
                                      </div>

                                      <div className="row row-botm">
                                        <div className="col-lg-6">
                                          <div className="form-group">
                                            <label>Cost</label>
                                            <input
                                              placeholder="0"
                                              maxLength={priceLimit}
                                              className={`form-control ${
                                                errors[option._id]?.additionalCost ? 'error-border' : ''
                                              }`}
                                              // value={option.additionalCost}
                                              value={
                                                option.additionalCost
                                                  ? `$ ${Number(option.additionalCost).toLocaleString()}`
                                                  : ''
                                              }
                                              onChange={(e) => {
                                                const value = e.target.value.replace(/[^0-9]/g, '');
                                                handleOptionChange(option._id, 'additionalCost', value);
                                              }}
                                            />
                                          </div>
                                        </div>

                                        <div className="col-lg-6">
                                          <div className="form-group ">
                                            <label>Number of Days</label>
                                            <input
                                              maxLength={priceLimit}
                                              placeholder="0"
                                              className={`form-control ${
                                                errors[option._id]?.numberOfDays ? 'error-border' : ''
                                              }`}
                                              value={option.numberOfDays}
                                              onChange={(e) => {
                                                const value = e.target.value.replace(/[^0-9]/g, '');
                                                if (Number(value) <= 365) {
                                                  handleOptionChange(option._id, 'numberOfDays', value);
                                                } else {
                                                  appToast(
                                                    'The Number of Days value must not exceed 365.',
                                                    TOAST_TYPE.WARNING
                                                  );
                                                }
                                              }}
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  {/* DELETE */}
                                  {!(options.length === 1 && isOptionEmpty(option)) && (
                                    <span
                                      className="remove-option"
                                      onClick={() => {
                                        setOptionToDelete(option._id);
                                        setShowDeleteModal(true);
                                      }}>
                                      Delete
                                    </span>
                                  )}
                                </div>
                              </div>
                            )}
                          </Draggable>
                        ))}

                        {provided.placeholder}

                        {/* ADD OPTION */}
                        <div className="option-cardCover option-carddash-border">
                          <div className="add-option-item">
                            <a className="add-item" onClick={handleAddOption}>
                              +
                            </a>
                            <p>Add Option</p>
                          </div>
                        </div>
                      </div>
                    )}
                  </Droppable>
                </DragDropContext>
              </div>
              <div className="create-btn-cover">
                <button className="btn-black w-full" onClick={handleGenerateEstimate}>
                  {isEditing ? 'Update' : 'Generate'} Estimate
                </button>
              </div>
            </>
          ) : (
            <>
              {/* screnn 2 start code */}
              <div className="create-card mt-30">
                <div className="dashboard-card">
                  <h2>{changeOrderDetails?.title || 'Change Order'}</h2>
                  {/* {changeOrderDetails?.description && ( */}
                  <p>{changeOrderDetails?.description}</p>
                  {/* )} */}
                  <b>Expiration period set to {expirationDays} days</b>
                </div>

                {/* map your options here dynamically instead of static */}
                {options.map((opt) => (
                  <div className="dashboardCard-cover" key={opt._id}>
                    <div className="card-topheader">
                      <p>{opt.title || 'Option'}</p>
                      <span>${formatCurrency(opt.additionalCost)}</span>
                    </div>

                    <div className="dashboardCard-content">
                      {/* <label>{opt.title}</label> */}
                      <p>{opt.description}</p>

                      <ul className="content-list">
                        {opt.lineItems.map((item) => (
                          <li key={item.id}>{item.title}</li>
                        ))}
                      </ul>

                      <div className="content-details">
                        <label>
                          Timeline: <span>{opt.numberOfDays} days</span>
                        </label>
                        {/* <label>
                          Revisions: <span>3 included</span>
                        </label> */}
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              <div className="create-btn-cover">
                <button className="btn-black" onClick={handleSaveEstimate}>
                  {loading ? selectLoader(25) : isEditing ? 'Update' : 'Save'}
                </button>

                <Popover
                  isOpen={showShare}
                  positions={['top']}
                  align="center"
                  padding={4}
                  reposition={false}
                  onClickOutside={() => setShowShare(false)}
                  content={
                    <ShareClientPopover
                      members={members}
                      selectedUsers={selectedUsers}
                      onSelect={handleSelectUser}
                      onRemove={handleRemoveUser}
                      onClose={() => setShowShare(false)}
                      onShare={handleShareQuote}
                      shareLoading={shareLoading}
                    />
                  }>
                  <button
                    className={`btn-black ${!currentQuoteId ? 'disabled-btn' : ''}`}
                    onClick={() => setShowShare((prev) => !prev)}
                    disabled={!currentQuoteId}>
                    Share with client
                  </button>
                </Popover>
              </div>
            </>
          )}
        </div>
      </div>
      <DeleteModal
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        handleDelete={confirmDeleteOption}
        itemName="option"
      />
    </div>
  );
};

export default CreateEstimate;
